import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./landing.component.scss'],
    
})
export class LandingComponent {
}
